export class DocumentPropertiesMapper {
  public static MapToVisualizationMode(data: any): any {
    return {
      General : {
        Label : data.Label,
        Keywords : data.Keywords,
        DocumentType : data.DocumentType
      }
    }
  }
}
